<template>
  <CContainer>
    <h6>
        Esta sección le permite conocer el Catálogo de Productos que ofrece el proveedor a la empresa. En este catálogo puede ver en detalle los productos y sus carácteristicas.
    </h6>
    <ImageGallery :cartMode="false" :data="products"/>
    <CElementCover v-if="loading"/>    
  </CContainer>
</template>

<script>
  import ImageGallery from '../containers/ImageGallery'
  import { dataGridProductosPedidos } from '../../api'
  
  export default {
    name: "ProductsList",
    data(){
      return {
        category: '',
        subcategory: '',
        brand: '',
        search: '',
        products: [],
        loading: false
      }
    },
    components: {
      ImageGallery
    },
        methods: {
      async getData() {
        try {
          this.loading = true
          const { response } = await dataGridProductosPedidos(this, this.$store.state.user.data.id_Directorio)          
          this.products = response
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally{
          this.loading = false
        }
      },
    },
    mounted(){
      this.getData()
    }
  }
</script>